var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSolLogo = function SvgSolLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508.07 398.17"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol-logo_svg__a",
    x1: 463,
    y1: 205.16,
    x2: 182.39,
    y2: 742.62,
    gradientTransform: "translate(0 -198)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc1fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol-logo_svg__b",
    x1: 340.31,
    y1: 141.1,
    x2: 59.71,
    y2: 678.57,
    xlinkHref: "#sol-logo_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol-logo_svg__c",
    x1: 401.26,
    y1: 172.92,
    x2: 120.66,
    y2: 710.39,
    xlinkHref: "#sol-logo_svg__a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M84.53 358.89A16.63 16.63 0 0 1 96.28 354h405.45a8.3 8.3 0 0 1 5.87 14.18l-80.09 80.09a16.61 16.61 0 0 1-11.75 4.86H10.31A8.31 8.31 0 0 1 4.43 439Z",
    transform: "translate(-1.98 -55)",
    style: {
      fill: "url(#sol-logo_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.53 59.85A17.08 17.08 0 0 1 96.28 55h405.45a8.3 8.3 0 0 1 5.87 14.18l-80.09 80.09a16.61 16.61 0 0 1-11.75 4.86H10.31A8.31 8.31 0 0 1 4.43 140Z",
    transform: "translate(-1.98 -55)",
    style: {
      fill: "url(#sol-logo_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.51 208.42a16.61 16.61 0 0 0-11.75-4.86H10.31a8.31 8.31 0 0 0-5.88 14.18l80.1 80.09a16.6 16.6 0 0 0 11.75 4.86h405.45a8.3 8.3 0 0 0 5.87-14.18Z",
    transform: "translate(-1.98 -55)",
    style: {
      fill: "url(#sol-logo_svg__c)"
    }
  }));
};
export default SvgSolLogo;